import _ from 'lodash'
import api from '../../api'
import router from '../../router'
import socket from '../../plugins/socketIO'

const defaultState = () => ({
  templates: [],
  currentTemplate: []
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    getAllGameTemplates: state => state.templates
  },
  actions: {
    async getAllTemplates({ commit, getters }){
        const { data }  = await api.gameTemplate.findAllGameTemplates()
        console.log("Všechny šablony")
        console.log(data)
        commit("SET_ALL_TEMPLATES", data)
    },
    async saveTemplate({ commit, getters }, template){
      console.log("Šablona")
      console.log(template)
      var sablona = template
      await api.gameTemplate.saveGameTemplate({
        id: template.data.id,
        template: sablona})
    },
    async getTemplateById({commit, getters}, id){
     const data = await api.gameTemplate.findGameTemplateById(id);
     console.log("Posílám")
     //commit("SET_CHOOSEN_TEMPLATE", data);
     return data
    },
    async deleteTemplate({ commit, getters }, template){
      await api.gameTemplate.deleteGameTemplateById(template.data.id)
    }

  },
  mutations: {
    SET_ALL_TEMPLATES(state, data) {
        
        state.templates = data || []
    },
    SET_CHOOSEN_TEMPLATE(state, data){
      state.currentTemplate = data || []
    }
  },
}

